"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
const styled_components_1 = __importDefault(require("styled-components"));
const BaseButton_1 = __importDefault(require("../BaseButton"));
const StyledButton = (0, styled_components_1.default)(BaseButton_1.default) `
  color: ${({ theme }) => theme.palette.common.white};
  background-color: ${({ theme }) => theme.palette.gray[100]};
  padding: 16px 14px;
  border-radius: 64px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.14),
    0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 1px 8px 0 rgba(0, 0, 0, 0.2);
  position: relative;
  min-height: 64px;
  min-width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;

  &.Mui-focusVisible:before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    box-shadow: ${({ theme }) => theme.constants.focusBoxShadow};
    border: ${({ theme }) => `2px solid ${theme.palette.blue[40]}`};
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.gray[70]};
  }

  &:active {
    background-color: ${({ theme }) => theme.palette.gray[70]};
  }

  &.Mui-disabled:disabled {
    pointer-events: auto;
    background-color: ${({ theme }) => theme.palette.gray[10]};
    box-shadow: none;
  }

  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    min-height: 36px;
    min-width: 36px;
    border-radius: 36px;

    &:before {
      border-radius: 36px;
    }
  }
`;
/**
 * _Floating Action Button_
 *
 * The FAB is used to guide an action on the page.
 * For example; arrows are used as a FAB to guide horizontal scrolling.
 * FABs contain an icon that is centered within a circular container.
 *
 * **Scaling for responsive screen size:**
 * For Medium to XL, the height and width are fixed at 64px.
 * For xsmall-small screen sizes the height and width should not be less than 36px.
 * */
const FAB = (props) => ((0, jsx_runtime_1.jsx)(StyledButton, { touchRippleColor: (0, styles_1.useTheme)().palette.gray[100], ...props }));
exports.default = FAB;
//# sourceMappingURL=index.js.map